export default __webpack_public_path__ + "static/media/See_Token_Info.d38dc6e7.svg";